module.exports = __webpack_public_path__ + "39fd30e2.webp";